import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";

export const resetSelectCar = (): AnyAction =>
  myFleetActions.setSelectCar(null);
